export const Roles = {
  PATIENT: "PATIENT",
  DOCTOR: "DOCTOR",
};
